export enum OrganizationErrorCodeType {
    InvalidOrganizationName = 'InvalidOrganizationName',
    InvalidOrganizationDnsName = 'InvalidOrganizationDnsName',
    UnavailableOrganizationDnsName = 'UnavailableOrganizationDnsName',
    UnauthorizedOrganizationClaim = 'UnauthorizedOrganizationClaim',
    CurrentUserNotAnOrganizationUser = 'CurrentUserNotAnOrganizationUser',
    OrganizationNotFound = 'OrganizationNotFound',
    OrganizationUserInvalidEmail = 'OrganizationUserInvalidEmail',
    OrganizationUserAlreadyExists = 'OrganizationUserAlreadyExists',
    OrganizationUsersNotFoundInOrganization = 'OrganizationUsersNotFoundInOrganization',
}
